import React, { useContext, useEffect, useState } from "react";
import { Container, Tabs, Tab, Image } from "react-bootstrap";
import { OrdersContext } from "../../context/orders.context";
import RFQTable from "../../component/RFQTable";
import OrderTable from "../../component/OrderTable";
import {
  fetchOrderForSupplier,
  fetchQuotationsForSupplier,
  getOrderForSupplier,
  getRFQForSupplier,
} from "../../utils/actions/userActions";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { checkIfAllPartsInvoicedForPO, validateUser } from "../../utils/helper";
import { toast } from "react-toastify";
import qs from "query-string";
import { processType } from "../../utils/constant";
import moment from "moment";
import activeOrdersImg from "../../assets/activeOrders.svg";
import underReviewImg from "../../assets/underReview.svg";
import unapprovedImg from "../../assets/unapprovedQuotes.svg";
import pendingForQuotationImg from "../../assets/pendingForQuotation.svg";
import closedOrderImg from "../../assets/closedOrders.svg";
import shippedImage from "../../assets/shipped-icon.svg";
import deliveryImage from "../../assets/delivery-icon.svg";
import { Loading } from "../../component/Loading";
import OfferTable from "../../component/OFFERTABLE";

const itemsPerPage = 10;

const MyOrders = () => {
  const loggedInUserToken = localStorage.getItem("Token");
  const supplierId = localStorage.getItem("supplierId");
  const { search } = window.location;
  const params = qs.parse(search);
  const navigate = useNavigate();
  const { activeTab, setActiveTab, ordersCount, refresh, setOrdersCount } = useContext(OrdersContext);
  const [page, setPage] = useState(1);
  const [totalNumberOfPage, setTotalNumberOfPage] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("status");
  const setStatus = (status) => {
    const next = new URLSearchParams(searchParams);
    if (status) next.set("status", status);
    else next.delete("status");
    setSearchParams(next);
  };

  const [pendingRFQs, setPendingRFQs] = useState([]);
  const [pendingOffers, setPendingOffers] = useState([]);
  const [underReviewRFQs, setUnderReviewRFQs] = useState([]);
  const [unapprovedRFQs, setUnapprovedRFQs] = useState([]);
  const [rfqDataToShow, setRFQDataToShow] = useState([]);
  const [orderDataToShow, setOrderDataToShow] = useState([]);
  const [activeOrders, setActiveOrders] = useState([]);
  const [closedOrders, setClosedOrders] = useState([]);
  const [shippedOrders, setShippedOrders] = useState([]);
  const [billedOrders, setBilledOrders] = useState([]);
  const [filterValue, setFilterValue] = useState({
    refId: "",
    poNumber: "",
    selectedProcess: "",
    requestedDate: "",
    projectName: "",
    type: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  console.log(ordersCount, "ordersCount")
  useEffect(() => {
    setActiveTab(status);
  }, [status]);

  if (status == null) {
    setActiveTab('offer-pending-for-quotation');
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        if (activeTab == "pending-for-quotation" ||
          activeTab == "under-review" || activeTab == "offer-pending-for-quotation" ||
          activeTab == "unapproved-quotes" || activeTab == null
        ) {
          let status;
          switch (activeTab) {
            case 'pending-for-quotation':
              status = 'Pending for Quotation';
              break;
            case 'under-review':
              status = 'Under Review';
              break;
            case 'unapproved-quotes':
              status = 'Unapproved';
              break;
            case 'offer-pending-for-quotation':
              status = 'Offer Pending Acceptance';
              break;
            default:
              status = 'Offer Pending Acceptance';
              break;
          }
          const response = await getOrderForSupplier('rfq', loggedInUserToken, supplierId, filterValue.refId, filterValue.selectedProcess, filterValue.requestedDate, '', filterValue.projectName, status, page, itemsPerPage);

          console.log("Response ::", response);

          if (response && response.success) {
            const numberOfPage = Math.ceil(response.totalRecords / response.itemsPerPage);
            const count = response?.countData;
            console.log(count);
            const activeOrder = count['Active Orders'];
            const billedOrder = count['Billed Orders'];
            const closedOrder = count['Closed Orders'];
            const pendingOrder = count['Pending for Quotation'];
            const pendingOffer = count['Offer Pending Acceptance'];
            const unapprovedorder = count['Unapproved'];
            const underRevieworder = count['Under Review'];

            setOrdersCount({
              pendingForQuotation: pendingOrder,
              offerpendingForQuotation: pendingOffer,
              underReview: underRevieworder,
              activeOrders: activeOrder,
              shippedOrders: 0,
              deliveredOrders: 0,
              unapprovedQuotes: unapprovedorder,
              closedOrders: closedOrder,
              billedOrders: billedOrder,
            });
            setTotalNumberOfPage(numberOfPage);
            const data = response.data;
            setRFQDataToShow(data);
            setIsLoading(false);
          }

        }
        if (activeTab == 'closed-orders' || activeTab == 'billed-orders' || activeTab == 'active-orders') {
          let status;
          if (activeTab == 'closed-orders') {
            status = 'Closed'
          }
          if (activeTab == 'active-orders') {
            status = 'active';
          }
          if (activeTab == 'billed-orders') {
            status = 'billed'
          }
          const response = await getOrderForSupplier('orders', loggedInUserToken, supplierId, filterValue.refId, filterValue.selectedProcess, filterValue.requestedDate, filterValue.poNumber, filterValue.projectName, status, page, itemsPerPage);
          console.log("Response from supplier order ::", response);
          if (response && response.success) {


            const count = response?.countData;
            const activeOrder = count['Active Orders'];
            const billedOrder = count['Billed Orders'];
            const closedOrder = count['Closed Orders'];
            const pendingOrder = count['Pending for Quotation'];
            const pendingOffer = count['Offer Pending Acceptance'];
            const unapprovedorder = count['Unapproved'];
            const underRevieworder = count['Under Review'];
            console.log(pendingOffer, "pendingOffer")
            setOrdersCount({
              pendingForQuotation: pendingOrder,
              offerpendingForQuotation: pendingOffer,
              underReview: underRevieworder,
              activeOrders: activeOrder,
              shippedOrders: 0,
              deliveredOrders: 0,
              unapprovedQuotes: unapprovedorder,
              closedOrders: closedOrder,
              billedOrders: billedOrder,
            });

            const { itemsPerPage, totalRecords } = response;
            const numberOfPage = Math.ceil(totalRecords / itemsPerPage);
            setTotalNumberOfPage(numberOfPage);
            const data = response.data;
            setOrderDataToShow(data);
            setIsLoading(false);
          }
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
        toast.error("Data fetch failed. Please try again later");
      }
    }
    console.log(activeTab, "offer-pending-for-quotation");
    fetchData();
  }, [filterValue, page, activeTab]);

  const handleShowSelectedOrder = (activeTab) => {
    setActiveTab(activeTab);
    console.log(activeTab, "activeTab");

    setFilterValue({
      refId: "",
      poNumber: "",
      selectedProcess: "",
      requestedDate: "",
      projectName: "",
    });
  };

  const handleReferenceIdFilter = (e) => {
    setFilterValue({ ...filterValue, refId: e.target.value });

  };

  const handlePoNumberFilter = (e) => {
    setFilterValue({ ...filterValue, poNumber: e.target.value });

  };

  const handleProjectNameFilter = (e) => {
    setFilterValue({ ...filterValue, projectName: e.target.value });
  };

  const handleProcessFilter = (e) => {
    setFilterValue({ ...filterValue, selectedProcess: e.target.value });
  };

  const handleCreateAtFilter = (e) => {
    setFilterValue({ ...filterValue, requestedDate: e.target.value });

  };

  const handleReset = () => {
    if (activeTab == "pending-for-quotation") {
      setRFQDataToShow(pendingRFQs);
    } else if (activeTab == "under-review") {
      setRFQDataToShow(underReviewRFQs);
    }
    //  else if (activeTab == "unapproved-quotes") {
    //   setRFQDataToShow(unapprovedRFQs);
    // }
    else if (activeTab == "closed-orders") {
      setOrderDataToShow(closedOrders);
    } else if (activeTab == "active-orders") {
      setOrderDataToShow(activeOrders);
      // } else if (activeTab == "shipped-orders") {
      //   setOrderDataToShow(shippedOrders);
    } else if (activeTab == "billed-orders") {
      setOrderDataToShow(billedOrders);
    } else if (activeTab == "offer-pending-for-quotation") {
      setOrderDataToShow(pendingOffers);
    }

    setFilterValue({
      refId: "",
      poNumber: "",
      selectedProcess: "",
      requestedDate: "",
      projectName: "",
    });
  };
  return (
    <div>
      <div className="content-wrapper">
        {loggedInUserToken ? (
          <div>
            <div>
              <div className="intro-bar my-1.5">
                <div className="int-left">
                  <h3>Manage your orders</h3>
                  <p>
                    You can use advance search to find a particular order or
                    request.
                  </p>
                </div>
              </div>

              <div className="intro-bar flex flex-col">
                <div className="flex justify-between  w-full flex-wrap ">
                  <div className="filter-item">
                    <p>REFERENCE ID</p>
                    <input
                      value={filterValue.refId}
                      placeholder="Enter Ref ID"
                      onChange={handleReferenceIdFilter}
                    />
                  </div>

                  <div className="filter-item">
                    <p>PROJECT NAME</p>
                    <input
                      value={filterValue.projectName}
                      placeholder="Enter Project Name"
                      onChange={handleProjectNameFilter}
                    />
                  </div>

                  <div className="filter-item">
                    <p>MFG. PROCESS</p>
                    <select
                      value={
                        filterValue.selectedProcess
                          ? filterValue.selectedProcess
                          : "default"
                      }
                      onChange={handleProcessFilter}
                    >
                      <option value="default" disabled>
                        Select a MFG Process
                      </option>
                      {processType.map((item) => {
                        if (item.id != 9 && item.id != 10) {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          );
                        }
                      })}
                    </select>
                  </div>

                  <div className="filter-item">
                    <p>REQUESTED DATE</p>
                    <input
                      type="date"
                      value={filterValue.requestedDate}
                      placeholder="Select creation date"
                      onChange={handleCreateAtFilter}
                    />
                  </div>

                  {activeTab == "active-orders" ||
                    activeTab == "closed-orders" ||
                    activeTab == "billed-orders" ||
                    activeTab == "shipped-orders" ? (
                    <>
                      <div className="filter-item">
                        <p>PO NUMBER</p>
                        <input
                          value={filterValue.poNumber}
                          placeholder="Enter PO Number"
                          onChange={handlePoNumberFilter}
                        />
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="filter-item ">
                    <button
                      className="px-3 py-1 mt-4 bg-red-500 text-white rounded"
                      style={{ color: "red", fontWeight: "500" }}
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>

              <div
                className="intro-bar-for-tabs"
                style={{
                  width: "100%",
                }}
              >
                <Tabs
                  id="controlled-tab-example"
                  activeKey={activeTab}
                  onSelect={(k) => {
                    setActiveTab(k);
                    setStatus(k);
                    handleShowSelectedOrder(k);
                    setPage(1);
                    setFilterValue({
                      refId: "",
                      poNumber: "",
                      selectedProcess: "",
                      requestedDate: "",
                      projectName: "",
                    });
                  }}
                  className="qoute-version-tabs"
                  style={{ marginBottom: "-10px" }}
                >
                  <Tab
                    eventKey={"offer-pending-for-quotation"}
                    title={
                      <span className="tab-with-image">
                        <img
                          className="tab-image"
                          src={pendingForQuotationImg}
                          alt="pending-for-quotation-img"
                        />
                        {`Offer's (${ordersCount?.offerpendingForQuotation || 0})`}
                      </span>
                    }
                  ></Tab>

                  <Tab
                    eventKey={"pending-for-quotation"}
                    title={
                      <span className="tab-with-image">
                        <img
                          className="tab-image"
                          src={pendingForQuotationImg}
                          alt="pending-for-quotation-img"
                        />
                        {`RFQ's (${ordersCount.pendingForQuotation || 0})`}
                      </span>
                    }
                  ></Tab>

                  <Tab
                    eventKey={"under-review"}
                    title={
                      <span className="tab-with-image">
                        <img
                          className="tab-image"
                          src={underReviewImg}
                          alt="underReviewImg"
                        />
                        {`Under Review (${ordersCount.underReview || 0})`}
                      </span>
                    }
                  ></Tab>

                  <Tab
                    eventKey={"active-orders"}
                    title={
                      <span className="tab-with-image">
                        <img
                          className="tab-image"
                          src={activeOrdersImg}
                          alt="activeOrdersImg"
                        />
                        {`Active (${ordersCount.activeOrders || 0})`}
                      </span>
                    }
                  ></Tab>



                  <Tab
                    eventKey={"billed-orders"}
                    title={
                      <span className="tab-with-image">
                        <img
                          className="tab-image"
                          src={deliveryImage}
                          alt="activeOrdersImg"
                        />
                        {`Billed (${ordersCount.billedOrders})`}
                      </span>
                    }
                  ></Tab>

                  <Tab
                    eventKey={"closed-orders"}
                    title={
                      <span className="tab-with-image">
                        <img
                          className="tab-image"
                          src={closedOrderImg}
                          alt="closedOrderImg"
                        />
                        {`Completed (${ordersCount.closedOrders})`}
                      </span>
                    }
                  ></Tab>
                </Tabs>
              </div>

              {isLoading ? (
                <>
                  <Loading />
                </>
              ) : (
                <>
                  <div className="dashboard-holder">
                    <div className="dashboard-in">
                      {activeTab &&
                        (activeTab == "pending-for-quotation" ||
                          activeTab == "under-review") ? (
                        <RFQTable rFQData={rfqDataToShow} />
                      ) : activeTab == "active-orders" ||
                        activeTab == "closed-orders" ||
                        activeTab == "shipped-orders" ||
                        activeTab == "billed-orders" ? (
                        <OrderTable orderData={orderDataToShow} />
                      ) : (activeTab == "offer-pending-for-quotation") ? (
                        <OfferTable rFQData={rfqDataToShow} />)
                        : (
                          <></>)}
                    </div>
                  </div>
                </>
              )}
            </div>
            {!isLoading && (
              <nav aria-label="Page navigation example">
                <ul className="flex items-center justify-end h-10 text-base mx-10">
                  {/* Previous Button */}
                  {totalNumberOfPage >= 1 && (
                    <li>
                      <div
                        className={`flex items-center justify-center px-4 h-9 leading-tight text-gray-500 bg-white border border-gray-300 ${page === 1 ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                          }`}
                        onClick={() => page > 1 && setPage(page - 1)} // Disable if on the first page
                      >
                        Previous
                      </div>
                    </li>
                  )}

                  {/* Pagination Numbers */}
                  {(() => {
                    const totalPages = totalNumberOfPage;
                    const currentPage = page;

                    let paginationItems = [];

                    // Always show the first page
                    if (totalPages >= 1) {
                      paginationItems.push(
                        <li
                          key={1}
                          className={`${currentPage === 1 ? 'text-primaryColor' : ''}`}
                          onClick={() => setPage(1)}
                        >
                          <div
                            className={`flex items-center justify-center px-2 h-9 aspect-square leading-tight ${currentPage === 1
                              ? 'bg-primaryColor text-white'
                              : 'border border-primaryColor text-primaryColor'
                              } cursor-pointer`}
                          >
                            1
                          </div>
                        </li>
                      );
                    }

                    // Always show the second page
                    if (totalPages >= 2) {
                      paginationItems.push(
                        <li
                          key={2}
                          className={`${currentPage === 2 ? 'text-primaryColor' : ''}`}
                          onClick={() => setPage(2)}
                        >
                          <div
                            className={`flex items-center justify-center px-2 h-9 aspect-square leading-tight ${currentPage === 2
                              ? 'bg-primaryColor text-white'
                              : 'border border-primaryColor text-primaryColor'
                              } cursor-pointer`}
                          >
                            2
                          </div>
                        </li>
                      );
                    }

                    // Special case for showing page 3 when totalPages is 3
                    if (totalPages === 3) {
                      paginationItems.push(
                        <li
                          key={3}
                          className={`${currentPage === 3 ? 'text-primaryColor' : ''}`}
                          onClick={() => setPage(3)}
                        >
                          <div
                            className={`flex items-center justify-center px-2 h-9 aspect-square leading-tight ${currentPage === 3
                              ? 'bg-primaryColor text-white'
                              : 'border border-primaryColor text-primaryColor'
                              } cursor-pointer`}
                          >
                            3
                          </div>
                        </li>
                      );
                    }

                    // Show "..." if currentPage is beyond page 4
                    if (currentPage > 4 && totalPages > 5) {
                      paginationItems.push(
                        <li key="prevEllipsis" onClick={() => setPage(currentPage - 2)}>
                          <div className="flex items-center justify-center px-2 border h-9 aspect-square leading-tight text-primaryColor">
                            ...
                          </div>
                        </li>
                      );
                    }

                    // Calculate and show pages around the current page (dynamic range)
                    const startPage = Math.max(3, currentPage - 1); // Start page from currentPage - 1
                    const endPage = Math.min(totalPages - 2, currentPage + 1); // End page at currentPage + 1

                    for (let i = startPage; i <= endPage; i++) {
                      if (totalPages > 3) { // Only show dynamic pages if totalPages is greater than 3
                        paginationItems.push(
                          <li
                            key={i}
                            className={`${currentPage === i ? 'text-primaryColor' : ''}`}
                            onClick={() => setPage(i)}
                          >
                            <div
                              className={`flex items-center justify-center px-2 h-9 aspect-square leading-tight ${currentPage === i
                                ? 'bg-primaryColor text-white'
                                : 'border border-primaryColor text-primaryColor'
                                } cursor-pointer`}
                            >
                              {i}
                            </div>
                          </li>
                        );
                      }
                    }

                    // Show "..." if there are more pages after the current range
                    if (currentPage < totalPages - 3 && totalPages > 5) {
                      paginationItems.push(
                        <li key="nextEllipsis" onClick={() => setPage(currentPage + 2)}>
                          <div className="flex items-center justify-center px-2 border h-9 aspect-square leading-tight text-primaryColor">
                            ...
                          </div>
                        </li>
                      );
                    }

                    // Always show the last two pages if totalPages > 3
                    if (totalPages > 3) {
                      paginationItems.push(
                        <li
                          key={totalPages - 1}
                          className={`${currentPage === totalPages - 1 ? 'text-primaryColor' : ''}`}
                          onClick={() => setPage(totalPages - 1)}
                        >
                          <div
                            className={`flex items-center justify-center px-2 h-9 aspect-square leading-tight ${currentPage === totalPages - 1
                              ? 'bg-primaryColor text-white'
                              : 'border border-primaryColor text-primaryColor'
                              } cursor-pointer`}
                          >
                            {totalPages - 1}
                          </div>
                        </li>
                      );

                      paginationItems.push(
                        <li
                          key={totalPages}
                          className={`${currentPage === totalPages ? 'text-primaryColor' : ''}`}
                          onClick={() => setPage(totalPages)}
                        >
                          <div
                            className={`flex items-center justify-center px-2 h-9 aspect-square leading-tight ${currentPage === totalPages
                              ? 'bg-primaryColor text-white'
                              : 'border border-primaryColor text-primaryColor'
                              } cursor-pointer`}
                          >
                            {totalPages}
                          </div>
                        </li>
                      );
                    }

                    return paginationItems;
                  })()}

                  {/* Next Button */}
                  {totalNumberOfPage >= 1 && (
                    <li>
                      <div
                        className={`flex items-center justify-center px-4 h-9 leading-tight text-gray-500 bg-white border border-gray-300 ${page === totalNumberOfPage ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                          }`}
                        onClick={() => page < totalNumberOfPage && setPage(page + 1)}
                      >
                        Next
                      </div>
                    </li>
                  )}
                </ul>
              </nav>
            )}




          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default MyOrders;
